import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import DiamondTwoToneIcon from '@mui/icons-material/DiamondTwoTone';
import { IconButton } from '@mui/material';
import { stacksApi, deruptarsNFTContractAddress } from '../../lib/constants';
import { useEffect, useState, useMemo } from 'react';
import './style.scss';
import { orange } from '@mui/material/colors';
// import { userSession } from '../../services/auth';
// import Mint from '../../services/mint';

const ViewOGBadge = ({ authorPrincipal, userSettings }) => {
    const [totalCount, setTotalCount] = useState(null);
    const [error, setError] = useState(null);
    const [retryCount, setRetryCount] = useState(0);

    // const [inMempool, setInMempool] = useState({ state: false, total: 0 });

    // let authenticatedUser;
    // if (userSession.isUserSignedIn()) {
    //     authenticatedUser = userSession.loadUserData().profile.stxAddress.mainnet;
    // }

    // let cancelled = false;

    useMemo(() => {
        let cancelled = false;
        let count = 0;

        async function fetchData() {
            try {
                const rawResponse = await fetch(`${userSettings?.stacksApi || stacksApi}/extended/v1/tokens/nft/holdings?principal=${authorPrincipal}&asset_identifiers=${deruptarsNFTContractAddress}`);
                if (!rawResponse.ok) {
                    throw new Error(`Request failed with status ${rawResponse.status}`);
                }
                const response = await rawResponse.json();
                count = response.total;
                if (!cancelled) {
                    setTotalCount(count);
                }
                // if (count === 0 && authenticatedUser === authorPrincipal) {
                //     let memPool = await fetch(`${userSettings?.stacksApi || stacksApi}/extended/v1/tx/mempool?sender_address=${authenticatedUser}`)
                //     memPool = await memPool.json()
                //     let memPoolTx = memPool.results.filter(data => data.contract_call);
                //     memPoolTx = memPoolTx.filter(data => data.contract_call.contract_id === deruptarsNFTContractAddress.split(':')[0]);
                //     setInMempool({ state: memPoolTx.length > 0 ? true : false, total: memPoolTx.length > 0 ? memPoolTx.length : 0 });
                // }
            } catch (err) {
                if (retryCount < 3) {
                    // retry the fetch
                    setRetryCount(retryCount + 1);
                } else {
                    // set the error state after retries have failed
                    setError(err.message);
                }
            }
        }

        fetchData();

        return count;
    }, [authorPrincipal, userSettings, retryCount]);

    // useEffect(() => {
    //     return () => {
    //         cancelled = true;
    //     };
    // }, [inMempool]);

    useEffect(() => {

    }, [authorPrincipal])

    return (
        <>
            {(error || totalCount === undefined) && <div id="ogNOT" />}
            {totalCount === 1 && <IconButton id='ogMint'> <CheckCircleTwoToneIcon sx={{ color: orange[50] }} fontSize='large' /></IconButton>}
            {totalCount >= 2 && <IconButton id='ogMint'> <DiamondTwoToneIcon sx={{ color: orange[50] }} fontSize='large' /></IconButton>}
        </>
    )
};

export default ViewOGBadge;
